// @flow
import { isNil } from 'ramda'

import { Storage } from 'utils/storage'

import { STORAGE_KEY } from './data'
import type { FormSpyValues, UpdateUserInterestsRequest, UserInterests } from './types'

const USER_INTERESTS_HANDLERS = [
  ({ disciplines }: UserInterests): $Shape<FormSpyValues> => {
    if (disciplines.length) {
      const disciplineId = disciplines[0].id

      return { discipline_id: disciplineId }
    }

    return {}
  },
  ({ gradeId }: UserInterests): $Shape<FormSpyValues> => (isNil(gradeId) ? {} : { grade_id: gradeId }),
  ({ levelId }: UserInterests): $Shape<FormSpyValues> => (isNil(levelId) ? {} : { level_id: levelId }),
]

export const transformUserInterests = (userInterests: UserInterests) =>
  USER_INTERESTS_HANDLERS.reduce<FormSpyValues>((memo, handler) => {
    const formSpyValues = handler(userInterests)

    return { ...memo, ...formSpyValues }
  }, {})

const FORM_SPY_VALUES_HANDLERS = [
  ({ discipline_id: id }) => ({ discipline_ids: isNil(id) ? [] : [id] }),
  ({ grade_id: id }) => ({ grade_id: isNil(id) ? null : id }),
  ({ level_id: id }) => ({ level_id: isNil(id) ? null : id }),
]

export const transformFormSpyValues = (formSpyValues: FormSpyValues) =>
  FORM_SPY_VALUES_HANDLERS.reduce<UpdateUserInterestsRequest>((memo, handler) => {
    const userInterests = handler(formSpyValues)

    return { ...memo, ...userInterests }
  }, {})

const PROPERTIES_TO_COMPARE = ['discipline_id', 'grade_id', 'level_id']

export const compareFormSpyValues = (a: FormSpyValues, b: FormSpyValues): boolean =>
  PROPERTIES_TO_COMPARE.every((prop) => a[prop] === b[prop])

/*
  Функция для извлечения из storage значений
  сохраненных в FormSpyManager.STORAGE_KEY
*/
export const getStorageValues = (): FormSpyValues => {
  if (!Storage.getItem(STORAGE_KEY)) return {}

  const values = Storage.getJson(STORAGE_KEY)

  if (values === null) return {}

  return values
}

/**
 * Return value from spy storage
 */
export const getStorageValue = (name: $Keys<FormSpyValues>): $Values<FormSpyValues> => {
  const values = getStorageValues()

  if (values === null) return undefined

  return values[name] ?? undefined
}

export const setStorageValues = (values: FormSpyValues): void => {
  Storage.setJson(STORAGE_KEY, values)
}
